module.exports = __webpack_public_path__ + "static/img/topLeftImg.0338200.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/topLeftImg.png
// module id = CYtn
// module chunks = 1